import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles_m/tiles_m.css';
import '../styles/other.css';
import Axios from 'axios';
import { Link } from "react-router-dom";
import { navigate } from "@reach/router";

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';

class AddApplicationTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            listOfProjects: ([{id:1, label: "Project 1"},{id:2, label: "Project 2"},{id:3, label: "Project 3"}]),
            selectedProject: 0,
            note: "",
        }
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {


    }

    render() {
        return (
            <div className={"universalAddTile"} style={{position: "relative"}}>
                <span className="fontPoppinsSemiBold15 clickable">Add Application</span>

                <div style={{position: "relative", backgroundColor: "var(--lightest-gray)", marginTop: 20}}>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Requested Amount ($):*</span>
                        <input className="universalTextInput" type="number" style={{width: "100%", marginBottom: 5}} id="inputFirstName" name="inputFirstName" value={""} onChange={e => this.setState({ sectionLocationOpened: !this.state.sectionLocationOpened })}/>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Project:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="project" id="project" style={{}} value={this.state.selectedProject} onChange={e => this.setState({ selectedProject: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfProjects.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: -5}}>Note:*</span>
                        <textarea className="modalInputAddNote" rows="4" style={{backgroundColor: "white"}} placeholder="" id="textAreaNote" name="textAreaNote" value={this.state.note} onChange={e => this.setState({ note: e.target.value })}></textarea>
                    </div>

                    <div className="horizontalStack" style={{paddingLeft: 20, paddingTop: 10, paddingRight: 25, paddingBottom: 20}}>
                        <RoundButton title={"Add Application"} className={"roundButtonOrange"} onClick={this.createNewAction} whiteText={true} />
                    </div>
                </div>

            </div>
        );
    }
}

export default AddApplicationTile;
